import BarChartIcon from '@mui/icons-material/BarChart';

export const menus = [
    {
        title: 'Produção / Série Temporal',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/production-temporal',
        gap: true
    },
    {
        title: 'Perfil do Paciente',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/pacient-profile',
        gap: true
    },
    {
        title: 'Procedimentos / Produção',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/procedures',
        gap: true
    },
    {
        title: 'Financiamento / Fonte',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/financing',
        gap: true
    },
    {
        title: 'Estabelecimento / Série Localização',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/establishment-localization',
        gap: true
    },
    {
        title: 'Epidemiologia / Diagnósticos',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsciha/epidemiology',
        gap: true
    }
];
